<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
    <g>
      <path fill="none" d="M86.317,44.896c-22.755,0-41.296,18.542-41.296,41.297s18.542,41.297,41.296,41.297
        c22.755,0,41.296-18.542,41.296-41.297S109.072,44.896,86.317,44.896z M103.125,76.662c-3.59,0-6.5-2.91-6.5-6.5s2.91-6.5,6.5-6.5
        s6.5,2.91,6.5,6.5S106.715,76.662,103.125,76.662z"/>
      <path class="color" fill="#F45B5B" d="M162.888,150.253c0,0,0.112,0,0.112-0.009v0.086l-33.593-33.651c6.367-8.885,9.722-19.55,9.687-30.485
        c0-29.083-23.66-52.717-52.747-52.717c-29.083,0-52.732,23.634-52.732,52.717c0,29.087,23.626,52.717,52.709,52.717
        c11.42,0,21.791-3.604,30.49-9.747l33.642,33.472c1.673,1.759,3.954,2.634,6.151,2.634c2.196,0,4.625-0.789,6.212-2.634
        C166.242,159.22,166.303,153.677,162.888,150.253z M86.317,127.49c-22.755,0-41.296-18.542-41.296-41.297
        s18.542-41.297,41.296-41.297c22.755,0,41.296,18.542,41.296,41.297S109.072,127.49,86.317,127.49z"/>
      <circle class="color" fill="#F45B5B" cx="103.125" cy="70.162" r="6.5"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon'
}
</script>
